import React from 'react'
import ComponentType from '../../../data/types/components/ComponentType'
import HeaderComponent from '../HeaderComponent'
import HeroComponent from '../HeroComponent'
import FullWidthImageComponent from '../FullWidthImageComponent'
import NonFullWidthImageComponent from '../NonFullWidthImageComponent'
import FullWidthImageOverlayComponent from '../FullWidthImageOverlayComponent'
import { ComponentProps } from './ComponentProps'
import ParagraphComponent from '../ParagraphComponent'
import ContentColumnsComponent from '../ContentColumnsComponent'
import FeatureColumnsComponent from '../FeatureColumnsComponent'
import FooterComponent from '../FooterComponent'
import InvitationComponent from '../InvitationComponent'
import VideoComponent from '../VideoComponent'
import GalleryComponent from '../GalleryComponent'
import EmailBoxComponent from '../EmailBoxComponent'

const Component: React.FC<ComponentProps> = ({
  definition, index
}: ComponentProps) => {
  switch (definition.type) {
    case ComponentType.Header:
      return <HeaderComponent {...definition} />
    case ComponentType.Hero:
      return <HeroComponent {...definition} />
    case ComponentType.FullWidthImage:
      return <FullWidthImageComponent {...definition} index={index} />
    case ComponentType.NonFullWidthImage:
      return <NonFullWidthImageComponent {...definition} />
    case ComponentType.FullWidthImageOverlay:
      return <FullWidthImageOverlayComponent {...definition} />
    case ComponentType.Paragraph:
      return <ParagraphComponent {...definition} />
    case ComponentType.ContentColumns:
      return <ContentColumnsComponent {...definition} />
    case ComponentType.FeatureColumns:
      return <FeatureColumnsComponent {...definition} />
    case ComponentType.Invitation:
      return <InvitationComponent {...definition} />
    case ComponentType.Footer:
      return <FooterComponent {...definition} />
    case ComponentType.Video:
      return <VideoComponent {...definition} />
    case ComponentType.Gallery:
      return <GalleryComponent {...definition} />
    case ComponentType.EmailBox:
      return <EmailBoxComponent {...definition} />
    default:
      return null
  }
}

export default Component
